import React, {useState} from "react";
import PropTypes from "prop-types";
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'react-app-polyfill/ie11'
import img_new_main_member_register_step1 from 'images/img_new_main_member_register_step1.png';
import Error from "./Error";

const Step1 = (props) => {
  const [hasUniqueCodeInputError, setHasUniqueCodeInputError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [member, setMember] = useState(props.defaultMember);

  const onClickNextPage = () => {
    fetch(props.validate_step1_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': props.csrf_token
      },
      body: JSON.stringify({member : member})
    }).then((res) => {
      return res.json();
    }).then((data) => {
      setHasUniqueCodeInputError(false);
      if (data.status === 200) {
        props.slickGoTo(1);
      } else if(data.status === 400) {
        data.errors.forEach(errorParam => {
          if (errorParam.value === 'unique_code') {
            setErrorMessage(errorParam.reason);
            setHasUniqueCodeInputError(true);
          }
        });
      }
    }).catch((err) => {
      console.error(err);
    });
  };

  return (
    <div className="page_step1">
      <div className="input_area">
        <p>組合員番号を入力してください。</p>
        <div className="notice">
          <span>組合員番号について</span>
          所属の組合から発行されている10ケタの番号です。
          <ul className="asterisk">
            <li>組合員番号がわからない場合は<br className="pc"/>所属の組合にお問い合わせください。</li>
          </ul>
          <img src={img_new_main_member_register_step1} alt="unique_code_postcard"/>
        </div>
        <div className="input_group_area">
          <table>
            <tbody>
            <tr>
              <th>組合員番号</th>
              <td>
                <Error message={errorMessage} hasError={hasUniqueCodeInputError}/>
                <input type="text" tabIndex="1" id="form_index_1" defaultValue={member.unique_code} className="w100"
                       onChange={e => setMember({...member, unique_code: e.target.value})}/>
                <p className="notice">※半角英数字</p>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div className="input_group_area">
        <ul className="footer_button_area">
          <li>
            <a className="btn_entry next_page" id="form_index_2" tabIndex="2" onClick={onClickNextPage}>入力内容を確認する</a>
          </li>
        </ul>
      </div>
    </div>
  )
};

Step1.propTypes = {
  defaultMember: PropTypes.object,
  validate_step1_url: PropTypes.string,
  slickGoTo: PropTypes.func,
  csrf_token: PropTypes.string,
};

export default Step1;